import React from 'react'
import { MENU_OPTIONS, ROLE_OPTIONS } from './adminSettingsConstants'

interface RoleMenuFieldsProps {
  role: string
  allowedMenus: string[]
  onRoleChange: (role: string) => void
  onAllowedMenusChange: (allowedMenus: string[]) => void
}

function RoleMenuFields({ role, allowedMenus, onRoleChange, onAllowedMenusChange }: RoleMenuFieldsProps) {
  const toggleMenu = (menuKey: string) => {
    if (allowedMenus.includes(menuKey)) {
      onAllowedMenusChange(allowedMenus.filter((key) => key !== menuKey))
    } else {
      onAllowedMenusChange([...allowedMenus, menuKey])
    }
  }

  return (
    <>
      <label className='form-field'>
        역할
        <select value={role} onChange={(event) => onRoleChange(event.target.value)}>
          {ROLE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      {role === 'custom' && (
        <div className='menu-checkbox-grid'>
          {MENU_OPTIONS.map((menu) => (
            <label key={menu.key} className='menu-checkbox'>
              <input
                type='checkbox'
                checked={allowedMenus.includes(menu.key)}
                onChange={() => toggleMenu(menu.key)}
              />
              {menu.label}
            </label>
          ))}
        </div>
      )}
    </>
  )
}

export default RoleMenuFields
